if(window.location.pathname.includes("wholesale-signup-form")) {
    let counter = 0;
    let selector = "#accepts-marketing"
    const interval = setInterval(() => {
        let checkboxBtn = document.querySelector(selector);
        if (checkboxBtn) {
            checkboxBtn.checked = true;
            clearInterval(interval);
        } else {
            counter += 100;
            if (counter >= 10000) {
                clearInterval(interval);
            }
        }
    }, 100); 
}

